import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, Dialog, DialogContent, DialogTitle, IconButton, Stack, TextField } from '@mui/material';

interface Props {
  openModal: boolean;
  flushSpoofingState: () => void;
  spoofUrl: string;
  trip: string;
  copiedToClipboard: boolean;
}

function TripSpoofDialog({ openModal, flushSpoofingState, spoofUrl, trip, copiedToClipboard }: Props) {
  return (
    <Dialog open={openModal} onClose={flushSpoofingState}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between">
          <Box>Spoofing Link Generated</Box>
          <IconButton edge="end" color="inherit" onClick={flushSpoofingState} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={1}>
          <Alert severity={copiedToClipboard ? 'warning' : 'info'}>
            {copiedToClipboard
              ? `Spoofing link for ${trip} has been copied to the clipboard! (EXTREME CAUTION, PASTE INTO INCOGNITO ONLY)`
              : `Spoofing link for ${trip} could not be copied automatically. Copy it manually below. (EXTREME CAUTION, PASTE INTO INCOGNITO ONLY)`}
          </Alert>
          <TextField
            value={spoofUrl}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default TripSpoofDialog;
